document.addEventListener("alpine:init", () => {
    Alpine.data("Footer", () => ({
        temp: false,
    }));
});
